var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "overlay",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.recipientNameAndAccountId,
            "on-close": _vm.handleOverlayClose
          }
        },
        [
          _c("div", { staticClass: "disp-flex" }, [
            _c("div", { staticClass: "ml-auto mb-10" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "mini",
                        type: "success"
                      },
                      on: { click: _vm.handleResolve }
                    },
                    [_vm._v(_vm._s(_vm.$t("resolve")))]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.primaryInvoice
            ? _c(
                "div",
                { staticClass: "disp-flex" },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "ml-auto mb-10",
                      attrs: { type: "warning" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t("primaryInvoice")) + " : "
                      ),
                      _c("b", [
                        _vm._v(_vm._s(_vm.primaryInvoice.invoice_number))
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                size: "mini",
                "label-position": "top",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "mr-30",
                  staticStyle: { width: "350px" },
                  attrs: {
                    prop: "reason_for_call",
                    label: _vm.$t("reasonForCall")
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("reason_for_call") },
                    on: { input: _vm.handleInput },
                    model: {
                      value: _vm.form.reason_for_call,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "reason_for_call", $$v)
                      },
                      expression: "form.reason_for_call"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "350px" },
                  attrs: { prop: "callResult", label: _vm.$t("callResult") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select" },
                      on: { change: _vm.handleInput },
                      model: {
                        value: _vm.form.callResult,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "callResult", $$v)
                        },
                        expression: "form.callResult"
                      }
                    },
                    _vm._l(_vm.resultCategories, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.translateNoteCategory(item),
                          value: item
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "mt-20",
                    staticStyle: { "max-width": "350px" },
                    attrs: { type: "textarea", rows: "3" },
                    on: { input: _vm.handleInput },
                    model: {
                      value: _vm.form.callResultDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "callResultDescription", $$v)
                      },
                      expression: "form.callResultDescription"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-20" }, [
            _c("span", { staticClass: "bold fc-form-label" }, [
              _vm._v(_vm._s(_vm.$tc("contact", 777)))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "contacts-tray" },
              [
                _vm.recipient && _vm.recipient.reference
                  ? [
                      _c("contacts", {
                        attrs: {
                          recipient: _vm.recipient.reference,
                          selectable: true,
                          "on-select": _vm.handleContactSelect,
                          disabled: _vm.disabledContacts
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }